import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { CalendarDays, FileText, ListChecks } from "lucide-react";

const HORIZONS = [{ d: 30, l: "30 giorni" }, { d: 90, l: "90 giorni" }, { d: 180, l: "6 mesi" }, { d: 365, l: "12 mesi" }];

export default function Calendario() {
  const [events, setEvents] = useState([]);
  const [horizon, setHorizon] = useState(90);

  useEffect(() => { api.get("/calendar", { params: { horizon } }).then((r) => setEvents(r.data.events)); }, [horizon]);

  return (
    <div className="ri-fade-in max-w-4xl">
      <PageHeader overline="Regulatory Calendar" title="Calendario"
        subtitle="Publication, effective, implementation e consultation dates, oltre alle scadenze interne."
        actions={
          <div className="flex items-center rounded-lg border border-slate-200 overflow-hidden text-xs font-medium">
            {HORIZONS.map((h) => (
              <button key={h.d} onClick={() => setHorizon(h.d)} data-testid={`cal-horizon-${h.d}`}
                className={`px-3 py-1.5 ${horizon === h.d ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"}`}>{h.l}</button>
            ))}
          </div>
        } />

      <div className="relative border-l-2 border-slate-200 ml-3 space-y-4">
        {events.length === 0 && <div className="pl-6 text-slate-400 text-sm">Nessun evento nell'orizzonte selezionato.</div>}
        {events.map((e, i) => (
          <div key={i} data-testid={`cal-event-${i}`} className="relative pl-6">
            <span className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full border-2 border-white"
              style={{ background: e.kind === "task" ? "#EA580C" : "#2563EB" }} />
            <div className="rounded-xl bg-white border border-slate-200 p-4 flex items-start gap-3">
              {e.kind === "task" ? <ListChecks size={16} className="text-orange-600 mt-0.5" /> : <FileText size={16} className="text-blue-600 mt-0.5" />}
              <div className="flex-1">
                <div className="flex items-center gap-2 text-xs text-slate-400 font-mono">
                  <span>{e.date?.slice(0, 10)}</span>·<span>{e.label}</span>·<span>{e.authority}</span>
                </div>
                <div className="text-sm font-medium mt-0.5">
                  {e.reg_id ? <Link to={`/app/radar/${e.reg_id}`} className="hover:text-blue-700">{e.title}</Link> : e.title}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
